import { Typography } from '@material-ui/core';
import ReactHookTextField from 'components/ReactHookTextField';
import SelectWithDataReactHook from 'components/SelectWithDataReactHook';
import { finishOptions } from 'constants/finishing';

const Pedestal = ({ control, tableView }) => {
    return (
        <>
            {!tableView ? <Typography variant="h6" gutterBottom>Pedestal</Typography> : <br/>}
            <ReactHookTextField
                name='attributes.pedestalQty'
                type='text'
                control={control}
                 
                label='Qty'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.pedestalMaterial'
                type='text'
                control={control}
                 
                label='Material'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.pedestalNotes'
                type='text'
                control={control}
                label='Notes'
                style={{width: '19%', marginRight: '1%'}}
            />
            <SelectWithDataReactHook
                name='attributes.pedestalFinish'
                control={control}
                label='Finish'
                options={finishOptions}
                style={{width: '14%', marginRight: '1%'}}
            />
        </>   
    );
};

export default Pedestal;
